<template>
    <switch-theme-message />
</template>

<script>
import store from "@/store/store";
import { computed } from "vue";
import { useRouter } from "vue-router";
import { actionTypes as publisherActionTypes, getterTypes, LS_KEYS } from "@/store/Publisher/types";
import { getItem } from "@/store/persistantStorage";
import SwitchThemeMessage from "@/components/SwitchThemeMessage.vue";

export default {
    name: "Dashboard",
    components: { SwitchThemeMessage },
    setup() {
        const router = useRouter();

        const publishers = computed(() => store.getters[getterTypes.getPublishers] || []);

        const loadAndUpdateData = async () => {
            if (!publishers.value || publishers.value.length === 0) {
                await store.dispatch(publisherActionTypes.getData);
            }

            const publishersList = store.getters[getterTypes.getPublishers] || [];
            if (publishersList.length === 0) return;

            const hasYield = publishersList.some((p) => p.is_yield === true);
            const hasLtba = publishersList.some((p) => p.is_yield === false);
            const lastMode = getItem(LS_KEYS.MODE);

            // Picker-selected publishers are owned by DashboardYield/Ltba (restoreFromLS
            // + auto-select-all watch). This shim only decides which dashboard to open.
            if (lastMode === "yield" && hasYield) {
                router.replace({ name: "dashboard-yield" });
            } else if (lastMode === "ltba" && hasLtba) {
                router.replace({ name: "dashboard-ltba" });
            } else if (hasYield) {
                router.replace({ name: "dashboard-yield" });
            } else {
                router.replace({ name: "dashboard-ltba" });
            }
        };

        loadAndUpdateData();

        return {};
    },
};
</script>
